interface DashboardInsightsViewProps {
  userId: string;
}

export default function DashboardInsightsView({}: DashboardInsightsViewProps) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Insights</h2>
        <p className="text-gray-600">AI-powered insights and token savings</p>
      </div>

      <div className="text-center py-12 bg-white rounded-2xl border border-gray-200">
        <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Insights Coming Soon</h3>
        <p className="text-gray-500 max-w-md mx-auto">
          We're analyzing your usage patterns to provide personalized insights and recommendations.
        </p>
      </div>

      {/* Info about TOON benefits */}
      <div className="mt-6 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">Maximize Your Savings</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              TOON format reduces token usage by an average of 40%. By converting your JSON data to TOON before sending to LLMs,
              you can significantly reduce API costs and improve response times. Consider using TOON for large datasets and repetitive API calls.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
